export default __webpack_public_path__ + "static/media/html.485b6e20.png";